import { render, staticRenderFns } from "./HorseRaceLamp.vue?vue&type=template&id=07cbd50b&scoped=true"
import script from "./HorseRaceLamp.vue?vue&type=script&lang=js"
export * from "./HorseRaceLamp.vue?vue&type=script&lang=js"
import style0 from "./HorseRaceLamp.vue?vue&type=style&index=0&id=07cbd50b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cbd50b",
  null
  
)

export default component.exports